/// <reference types="vite/client" />
import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import useParties from '../useParties/useParties';
import { spiceroad } from '..';

export interface UseBatchLoanProps {
  activeTL: any;
  loanError: any;
  loanLoading: boolean;
  query: UseQueryResult<any>;
}

const getBatchLoan = (loanIds: string[]) =>
  spiceroad.get(`/v1/loans/batch/${loanIds.join(',')}`).then((res) => res.data);

export const getBatchLoanOpts = (loanIds: string[]) =>
  queryOptions({
    queryKey: ['batchLoan', loanIds],
    queryFn: () => getBatchLoan(loanIds),
  });

export function useBatchLoan(): UseBatchLoanProps {
  const { termLoans } = useParties();
  const query = useQuery({
    ...getBatchLoanOpts(termLoans),
    enabled: termLoans.length > 0,
  });
  const { data, error, isLoading } = query;

  return {
    activeTL:
      data?.loansByLoanIds?.find((loan: any) => loan.status === 'ACTIVE') ||
      null,
    loanError: error,
    loanLoading: isLoading,
    query,
  };
}

export default useBatchLoan;
